"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApprovalSheetGroup = exports.GroupTransitionLine = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var common_1 = require("../../../common");
var styles_1 = require("@material-ui/core/styles");
var Create_1 = __importDefault(require("@material-ui/icons/Create"));
var Delete_1 = __importDefault(require("@material-ui/icons/Delete"));
var styled_components_1 = __importDefault(require("styled-components"));
var react_intl_1 = require("react-intl");
var EllipsisBox_1 = require("../../../components/EllipsisBox");
var ApprovalSheetManagementContext_1 = require("../../../context/ApprovalSheetManagementContext");
var components_1 = require("../../../components");
var hooks_1 = require("../../../hooks");
exports.GroupTransitionLine = core_1.withTheme(styled_components_1.default(core_1.Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        min-width: 148px;\n        width: 100%;\n        height: 4px;\n        background-color: ", ";\n    "], ["\n        min-width: 148px;\n        width: 100%;\n        height: 4px;\n        background-color: ",
    ";\n    "])), function (_a) {
    var theme = _a.theme, hasResolution = _a.hasResolution, resolution = _a.resolution;
    var _b = theme.variables.palette.approval, backgroundColorError = _b.backgroundColorError, backgroundColorSuccess = _b.backgroundColorSuccess, borderColorBase = _b.borderColorBase;
    return hasResolution
        ? resolution === common_1.ApprovalSheetResolution.APPROVE
            ? backgroundColorSuccess
            : backgroundColorError
        : borderColorBase;
}));
var useApprovalSheetGroupStyles = styles_1.makeStyles(function (theme) {
    var _a = theme.variables.palette.approval, borderBase = _a.borderBase, borderRadiusBase = _a.borderRadiusBase, backgroundColorAccent = _a.backgroundColorAccent, management = _a.management, fontSizeSmaller = _a.fontSizeSmaller;
    var paddingVertical = management.paddingVertical, paddingHorizontal = management.paddingHorizontal, groupOffsetRight = management.groupOffsetRight, groupActionButtonSize = management.groupActionButtonSize;
    var groupTitlePadding = paddingVertical + " " + paddingHorizontal;
    return {
        container: {
            height: '100%',
            fontSize: fontSizeSmaller,
        },
        groupTypeAndLineContainer: {
            minWidth: function (_a) {
                var isNotLast = _a.isNotLast;
                return (isNotLast ? '280px' : '256px');
            },
        },
        groupTypeContainer: {
            paddingRight: '8px',
        },
        groupInfoContainer: {
            overflow: 'hidden',
            height: '100%',
            border: borderBase,
            borderRadius: borderRadiusBase,
            marginRight: function (_a) {
                var isNotLast = _a.isNotLast;
                return isNotLast ? groupOffsetRight : paddingHorizontal;
            },
            boxSizing: 'border-box',
        },
        groupInfoWrapper: {
            height: '100%',
        },
        groupTitleItem: {
            padding: groupTitlePadding,
            backgroundColor: backgroundColorAccent,
            fontSize: '14px',
        },
        groupTitleContainer: {
            height: function (_a) {
                var isEditSheet = _a.isEditSheet;
                return isEditSheet ? groupActionButtonSize : 'auto';
            },
        },
        groupActionButton: {
            width: groupActionButtonSize,
            height: groupActionButtonSize,
        },
        participantsOrderContainer: {
            padding: groupTitlePadding,
            borderTop: borderBase,
            borderBottom: borderBase,
            backgroundColor: backgroundColorAccent,
        },
        participantsContainer: {
            overflowY: 'auto',
            overflowX: 'hidden',
            height: '100%',
            padding: paddingVertical + " " + paddingHorizontal + " 0",
        },
        participantContainer: {
            paddingBottom: paddingVertical,
        },
    };
});
exports.ApprovalSheetGroup = function (props) {
    var group = props.group, isNotLast = props.isNotLast;
    var _a = react_1.useContext(ApprovalSheetManagementContext_1.ApprovalSheetManagementContext), isEditSheet = _a.isEditSheet, setEditGroup = _a.setEditGroup, setIsAddGroupModalOpenTrue = _a.setIsAddGroupModalOpenTrue, groupsUpdated = _a.groupsUpdated, setGroupsUpdated = _a.setGroupsUpdated;
    var participants = group.participants, groupIndex = group.index, isAfterActiveGroup = group.isAfterActiveGroup;
    var _b = hooks_1.useFlag(), confirmDeleteOpen = _b[0], setConfirmDeleteOpenTrue = _b[1], setConfirmDeleteOpenFalse = _b[2];
    var resolution;
    for (var index = 0; index < participants.length; index++) {
        var resolutionType = participants[index].resolutionType;
        resolution = resolutionType;
        if (resolutionType === common_1.ApprovalSheetResolution.REJECT) {
            break;
        }
    }
    var hasResolution = resolution !== undefined;
    var onEditGroupClick = function () {
        setEditGroup(group);
        setIsAddGroupModalOpenTrue();
    };
    var deleteGroupAction = function () {
        var newGroupsUpdated = __spreadArrays(groupsUpdated);
        var arrayIndex = groupIndex - 1;
        newGroupsUpdated.splice(arrayIndex, 1);
        var newGroupsLength = newGroupsUpdated.length;
        // начиная с индекса группы, которая заняла место удаленной приводим индексы в порядок:
        for (var index = arrayIndex; index < newGroupsLength; index++) {
            newGroupsUpdated[index].index = index + 1;
        }
        setGroupsUpdated(newGroupsUpdated);
    };
    var onDeleteGroupConfirm = function () {
        deleteGroupAction();
        return Promise.resolve().finally(setConfirmDeleteOpenFalse);
    };
    var isEditActionsShown = isEditSheet && isAfterActiveGroup;
    var theme = styles_1.useTheme();
    var _c = theme.variables.palette.approval.management, participantResolutionPaddingRight = _c.participantResolutionPaddingRight, participantResolutionSize = _c.participantResolutionSize;
    var classes = useApprovalSheetGroupStyles({ isNotLast: isNotLast, isEditSheet: isEditSheet });
    return (react_1.default.createElement(core_1.Grid, { container: true, direction: "column", justify: "flex-start", wrap: "nowrap", className: classes.container },
        react_1.default.createElement(core_1.Grid, { item: true },
            react_1.default.createElement(core_1.Grid, { container: true, direction: "row", alignItems: "center", wrap: "nowrap", className: classes.groupTypeAndLineContainer },
                react_1.default.createElement(core_1.Grid, { item: true, className: classes.groupTypeContainer },
                    react_1.default.createElement(core_1.Grid, { container: true, direction: "row", alignItems: "center", wrap: "nowrap" },
                        react_1.default.createElement(components_1.Resolution, { resolution: resolution, hasResolution: hasResolution }),
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "groupType." + group.groupType }))),
                isNotLast && react_1.default.createElement(exports.GroupTransitionLine, { item: true, hasResolution: hasResolution, resolution: resolution }))),
        react_1.default.createElement(core_1.Grid, { item: true, className: classes.groupInfoContainer },
            react_1.default.createElement(core_1.Grid, { container: true, direction: "column", wrap: "nowrap", className: classes.groupInfoWrapper },
                react_1.default.createElement(core_1.Grid, { item: true, className: classes.groupTitleItem },
                    react_1.default.createElement(core_1.Grid, { container: true, direction: "row", justify: "space-between", alignItems: "center", wrap: "nowrap", className: classes.groupTitleContainer },
                        react_1.default.createElement(core_1.Grid, { item: true },
                            react_1.default.createElement(EllipsisBox_1.EllipsisBox, { text: group.groupTitle, correctLength: 15 })),
                        isEditActionsShown && (react_1.default.createElement(core_1.Grid, { item: true },
                            react_1.default.createElement(core_1.Grid, { container: true, direction: "row", wrap: "nowrap" },
                                react_1.default.createElement(core_1.Grid, { item: true },
                                    react_1.default.createElement(core_1.Tooltip, { title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "editGroupButton" }) },
                                        react_1.default.createElement("div", null,
                                            react_1.default.createElement(core_1.IconButton, { className: classes.groupActionButton, onClick: onEditGroupClick },
                                                react_1.default.createElement(Create_1.default, null))))),
                                react_1.default.createElement(core_1.Grid, { item: true },
                                    react_1.default.createElement(core_1.Tooltip, { title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "deleteGroupButton" }) },
                                        react_1.default.createElement("div", null,
                                            react_1.default.createElement(core_1.IconButton, { className: classes.groupActionButton, onClick: setConfirmDeleteOpenTrue },
                                                react_1.default.createElement(Delete_1.default, null)))))))))),
                react_1.default.createElement(core_1.Grid, { item: true, className: classes.participantsOrderContainer }, group.parallel ? (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "participantsOrderParallel" })) : (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "participantsOrderConsecutive" }))),
                react_1.default.createElement(core_1.Grid, { container: true, item: true, direction: "column", wrap: "nowrap", className: classes.participantsContainer }, participants.map(function (participant, index) {
                    var resolutionType = participant.resolutionType;
                    var hasResolution = resolutionType !== undefined;
                    return (react_1.default.createElement(core_1.Grid, { item: true, key: participant.userId },
                        react_1.default.createElement(core_1.Grid, { container: true, direction: "row", wrap: "nowrap", alignItems: "center", className: classes.participantContainer },
                            react_1.default.createElement(core_1.Grid, { item: true },
                                react_1.default.createElement(components_1.Resolution, { resolution: resolutionType, hasResolution: hasResolution, size: participantResolutionSize, styles: { paddingRight: participantResolutionPaddingRight } })),
                            react_1.default.createElement(core_1.Grid, { item: true },
                                react_1.default.createElement(core_1.Grid, { container: true, direction: "row", spacing: 1, wrap: "nowrap", alignItems: "center" },
                                    react_1.default.createElement(core_1.Grid, { item: true }, index + 1 + "."),
                                    react_1.default.createElement(core_1.Grid, { item: true },
                                        react_1.default.createElement(EllipsisBox_1.EllipsisBox, { text: participant.fio, correctLength: 23 })))))));
                })))),
        react_1.default.createElement(components_1.ConfirmationDialog, { id: "confirm-delete-group", open: confirmDeleteOpen, onConfirm: onDeleteGroupConfirm, onCancel: setConfirmDeleteOpenFalse, confirmButtonText: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "deleteButton" }), message: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "deleteGroupConfirmMessage" }) })));
};
var templateObject_1;
